import { useEffect, useState } from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import KineticHero from "./components/KineticHero";
import EditorialMarquee from "./components/EditorialMarquee";
import ChapterThesis from "./components/ChapterThesis";
import ChapterCraft from "./components/ChapterCraft";
import CaseStudies from "./components/CaseStudies";
import PhotoReel from "./components/PhotoReel";
import ChapterBeyondBrief from "./components/ChapterBeyondBrief";
import ChapterJourney from "./components/ChapterJourney";
import ResumeDownload from "./components/ResumeDownload";
import ChapterArmory from "./components/ChapterArmory";
import ChapterContact from "./components/ChapterContact";
import Footer from "./components/Footer";

function App() {
  const [activeSection, setActiveSection] = useState("top");
  const [parallaxY, setParallaxY] = useState(0);

  useEffect(() => {
    const sections = [...document.querySelectorAll("[data-section]")];
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => entry.isIntersecting && setActiveSection(entry.target.dataset.section)),
      { rootMargin: "-18% 0px -66% 0px" },
    );
    sections.forEach((section) => observer.observe(section));
    const onScroll = () => setParallaxY(Math.min(window.scrollY * 0.04, 52));
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="portfolio-shell" id="top">
      <Navigation activeSection={activeSection} />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <ChapterThesis parallaxY={parallaxY} />
        <ChapterCraft />
        <CaseStudies />
        <PhotoReel />
        <ChapterBeyondBrief />
        <ChapterJourney />
        <ResumeDownload />
        <ChapterArmory />
        <ChapterContact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
